import React from 'react';

const ProBadge = ({ className = '', testId }) => (
  <span data-testid={testId || 'pro-badge'}
    className={`inline-flex items-center text-[9px] leading-none px-1.5 py-[3px] rounded font-bold tracking-wider text-[#0A0E27] ${className}`}
    style={{ background: 'linear-gradient(135deg,#fde047,#f59e0b)', boxShadow: '0 0 8px rgba(250,204,21,0.35)' }}>
    PRO
  </span>
);

export default ProBadge;
